import { css } from 'emotion';

export default {
    titleWrapper: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    `,
    titleContainer: css`
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    `,
    teamName: css`
        margin: 0;
        font-weight: 500;
        font-size: 26px;
    `,
    teamDetailsContainer: css`
        width: 100%;
        overflow: auto;
        padding: 10px;
    `,
    dashboardUsersContainer: css`
        display: flex;
        align-items: center;
    `,
    dashboardUsersIcon: css`
        margin-right: 10px;
    `,
    dashboardUsersCount: css`
        font-weight: 500;
        margin-left: 5px;
    `,
    driversContainer: css`
        display: flex;
        align-items: center;
        margin-top: 20px;
    `,
    driversIcon: css`
        margin-right: 10px;
    `,
    driversCount: css`
        font-weight: 500;
        margin-left: 5px
    `
}